import React from "react";

export default function ProfileMenu({ selectedSection, setSelectedSection, missingFields = [] }) {
  // Function to check if a section has missing fields
  const isSectionIncomplete = (sectionName) => {
    // Map of section names to their corresponding field prefixes
    const sectionToFieldMap = {
      "1. General Information": ["cv", "linkedin", "name", "lastName", "phone_number"],
      "3. Skills": ["top_achievement"],
      "5. Work Experience": ["work_experience_1", "work_experience_2"],
      "6. Future Position": ["minimum_salary", "ideal_salary", "working_style", "right_to_work"]
    };
    
    const fieldsForSection = sectionToFieldMap[sectionName] || [];
    
    // Check if any missing field belongs to this section
    return missingFields.some(field => 
      fieldsForSection.some(prefix => field.startsWith(prefix))
    );
  };

  return (
    <div className="w-full bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-semibold pt-4 pb-4">Profile</h2>
        
        <nav className="flex">
          {[
            { name: "1. General Information" },
            { name: "2. Profile Picture" },
            { name: "3. Skills" },
            { name: "4. Education" },
            { name: "5. Work Experience" },
            { name: "6. Future Position" },
          ].map((section) => (
            <button
              key={section.name}
              onClick={() => setSelectedSection(section.name)}
              className={`px-4 py-3 text-base border-b-2 transition-colors duration-200 relative ${
                selectedSection === section.name
                  ? "border-[#02B491] text-[#02B491] font-medium"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              {section.name}
              {isSectionIncomplete(section.name) && (
                <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs text-white">
                  i
                </span>
              )}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}
